import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Table, Card, Spinner, Tabs, Tab } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { authFetch } from "../utils/authFetch";

export default function D394Edit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [main, setMain] = useState({
    luna: "",
    an: "",
    tip_d394: "",
    tip_intocmit: "",
    den_intocmit: "",
    functie_intocmit: "",
    cif_intocmit: "",
    calitate_intocmit: "",
    adresar: "",
    functie_reprez: "",
    denr: "",
    cifr: "",
    telefon: "",
    schimb_optiune: "",
    optiune: "",
    numar_case_marcat: 0,
    numar_bonuri_fisc: 0,
    afiliate: ""
  });

  const [monetare, setMonetare] = useState([]);
  const [plaje, setPlaje] = useState([]);

  const loadData = async () => {
    setLoading(true);
    try {
      // 1. Main
      const mainData = await authFetch(`/d394/${id}`);
      if (mainData && mainData.length > 0) {
        setMain(mainData[0]);
      } else {
        toast.error("Declarația D394 nu a fost găsită.");
        navigate("/d394");
        return;
      }

      // 2. Monetare
      const monData = await authFetch(`/d394/detail-monetar/${id}`);
      setMonetare(monData || []);

      // 3. Plaje
      const plajData = await authFetch(`/d394/detail-plaja/${id}`);
      setPlaje(plajData || []);
    } catch (e) {
      toast.error(`Eroare la încărcarea datelor: ${e?.message || e}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [id]);

  const handleMainChange = (e) => {
    const { name, value } = e.target;
    setMain((prev) => ({ ...prev, [name]: value }));
  };

  const handleMonetarChange = (index, field, value) => {
    const updated = [...monetare];
    updated[index][field] = value;
    setMonetare(updated);
  };

  const handlePlajaChange = (index, field, value) => {
    const updated = [...plaje];
    updated[index][field] = value;
    setPlaje(updated);
  };

  const handleAddMonetar = () => {
    setMonetare([
      ...monetare,
      { bxid: null, d394_id: id, luna: main.luna, cota: 19, baza: 0.0, tva: 0.0 }
    ]);
  };

  const handleRemoveMonetar = (index) => {
    const updated = [...monetare];
    updated.splice(index, 1);
    setMonetare(updated);
  };

  const handleAddPlaja = () => {
    setPlaje([
      ...plaje,
      { bxid: null, d394_id: id, luna: main.luna, seria: "", p1: "", p2: "", p3: "", p4: "" }
    ]);
  };

  const handleRemovePlaja = (index) => {
    const updated = [...plaje];
    updated.splice(index, 1);
    setPlaje(updated);
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        ...main,
        bxid: id,
        details_monetar: monetare,
        details_plaja: plaje
      };
      const res = await authFetch("/d394/", {
        method: "POST",
        body: JSON.stringify(payload)
      });
      if (res.result === "pass") {
        toast.success("Declarația D394 a fost salvată!");
        loadData();
      } else {
        toast.error(res.message || "Eroare la salvare.");
      }
    } catch (err) {
      toast.error(`Eroare la salvare: ${err?.message || err}`);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Se încarcă datele declarației D394...</p>
      </div>
    );
  }

  return (
    <Container className="mt-4 pb-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>
          Editare Declarație D394 (Luna {main.luna} / Anul {main.an})
        </h2>
        <div>
          <Button variant="outline-secondary" onClick={() => navigate("/d394")} className="me-2">
            Înapoi la listă
          </Button>
          <Button variant="success" onClick={handleSave} disabled={saving}>
            {saving ? <Spinner size="sm" /> : "Salvează declarația"}
          </Button>
        </div>
      </div>

      <Form onSubmit={handleSave}>
        <Tabs defaultActiveKey="antet" className="mb-4">
          <Tab eventKey="antet" title="Antet & Date Intocmit">
            <Row>
              <Col md={6}>
                <Card className="mb-4 shadow-sm border-0">
                  <Card.Header className="bg-dark text-white fw-bold">Date Declarație & Firmă</Card.Header>
                  <Card.Body>
                    <Row>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>Tip Declarație</Form.Label>
                          <Form.Select name="tip_d394" value={main.tip_d394 || ""} onChange={handleMainChange}>
                            <option value="L">Lunar</option>
                            <option value="T">Trimestrial</option>
                            <option value="S">Semestrial</option>
                            <option value="A">Anual</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>Opțiune depunere</Form.Label>
                          <Form.Select name="optiune" value={main.optiune || ""} onChange={handleMainChange}>
                            <option value="1">Opțiune 1</option>
                            <option value="2">Opțiune 2</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Form.Group className="mb-2">
                      <Form.Label>Adresă / Sediu social</Form.Label>
                      <Form.Control as="textarea" rows={2} name="adresar" value={main.adresar || ""} onChange={handleMainChange} />
                    </Form.Group>
                    <Row>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>Telefon contact</Form.Label>
                          <Form.Control name="telefon" value={main.telefon || ""} onChange={handleMainChange} />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>Tranzacții Pers. Afiliate</Form.Label>
                          <Form.Select name="afiliate" value={main.afiliate || ""} onChange={handleMainChange}>
                            <option value="0">Nu</option>
                            <option value="1">Da</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>Număr Case Marcat</Form.Label>
                          <Form.Control type="number" name="numar_case_marcat" value={main.numar_case_marcat || 0} onChange={handleMainChange} />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>Număr Bonuri Fiscale</Form.Label>
                          <Form.Control type="number" name="numar_bonuri_fisc" value={main.numar_bonuri_fisc || 0} onChange={handleMainChange} />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              
              <Col md={6}>
                <Card className="mb-4 shadow-sm border-0">
                  <Card.Header className="bg-dark text-white fw-bold">Date Întocmit / Reprezentant</Card.Header>
                  <Card.Body>
                    <h6 className="text-secondary fw-bold mb-3 border-bottom pb-1">Persoană care o întocmește</h6>
                    <Form.Group className="mb-2">
                      <Form.Label>Calitate întocmit</Form.Label>
                      <Form.Select name="tip_intocmit" value={main.tip_intocmit || ""} onChange={handleMainChange}>
                        <option value="1">1 - Terti (societate de expertiză)</option>
                        <option value="2">2 - Persoană fizică autorizată</option>
                        <option value="3">3 - Salariat (Compartiment financiar)</option>
                      </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-2">
                      <Form.Label>Nume / Denumire</Form.Label>
                      <Form.Control name="den_intocmit" value={main.den_intocmit || ""} onChange={handleMainChange} />
                    </Form.Group>
                    <Row>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>CIF / CUI</Form.Label>
                          <Form.Control name="cif_intocmit" value={main.cif_intocmit || ""} onChange={handleMainChange} />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>Funcție / Calitate</Form.Label>
                          <Form.Control name="functie_intocmit" value={main.functie_intocmit || ""} onChange={handleMainChange} placeholder="Ex: Contabil sef" />
                        </Form.Group>
                      </Col>
                    </Row>

                    <h6 className="text-secondary fw-bold mt-4 mb-3 border-bottom pb-1">Reprezentant Legal (Firma)</h6>
                    <Form.Group className="mb-2">
                      <Form.Label>Nume Reprezentant</Form.Label>
                      <Form.Control name="denr" value={main.denr || ""} onChange={handleMainChange} />
                    </Form.Group>
                    <Row>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>CNP / CIF Reprez.</Form.Label>
                          <Form.Control name="cifr" value={main.cifr || ""} onChange={handleMainChange} />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group className="mb-2">
                          <Form.Label>Calitate / Funcție</Form.Label>
                          <Form.Control name="functie_reprez" value={main.functie_reprez || ""} onChange={handleMainChange} placeholder="Ex: Administrator" />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Tab>

          <Tab eventKey="monetare" title="Date Monetare">
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-dark text-white d-flex justify-content-between align-items-center">
                <span className="fw-bold">Rânduri Detalii Monetare</span>
                <Button variant="outline-light" size="sm" onClick={handleAddMonetar}>
                  + Adaugă Linie
                </Button>
              </Card.Header>
              <Card.Body className="p-0">
                <Table responsive striped hover className="mb-0">
                  <thead>
                    <tr>
                      <th>Cota TVA (%)</th>
                      <th>Baza Impozabilă</th>
                      <th>Valoare TVA</th>
                      <th className="text-end" style={{ width: "100px" }}>Acțiuni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {monetare.length === 0 ? (
                      <tr>
                        <td colSpan={4} className="text-center py-3 text-muted">
                          Nu s-au adăugat detalii monetare.
                        </td>
                      </tr>
                    ) : (
                      monetare.map((m, idx) => (
                        <tr key={m.bxid || idx}>
                          <td className="align-middle">
                            <Form.Control
                              type="number"
                              size="sm"
                              value={m.cota}
                              onChange={(e) => handleMonetarChange(idx, "cota", parseInt(e.target.value) || 0)}
                            />
                          </td>
                          <td className="align-middle">
                            <Form.Control
                              type="number"
                              size="sm"
                              step="0.01"
                              value={m.baza}
                              onChange={(e) => handleMonetarChange(idx, "baza", parseFloat(e.target.value) || 0.0)}
                              className="text-end"
                            />
                          </td>
                          <td className="align-middle">
                            <Form.Control
                              type="number"
                              size="sm"
                              step="0.01"
                              value={m.tva}
                              onChange={(e) => handleMonetarChange(idx, "tva", parseFloat(e.target.value) || 0.0)}
                              className="text-end"
                            />
                          </td>
                          <td className="align-middle text-end">
                            <Button variant="outline-danger" size="sm" onClick={() => handleRemoveMonetar(idx)}>
                              Șterge
                            </Button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab>

          <Tab eventKey="plaje" title="Plaje Facturi">
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-dark text-white d-flex justify-content-between align-items-center">
                <span className="fw-bold">Plaje de Facturi Alocate / Emise</span>
                <Button variant="outline-light" size="sm" onClick={handleAddPlaja}>
                  + Adaugă Plajă
                </Button>
              </Card.Header>
              <Card.Body className="p-0">
                <Table responsive striped hover className="mb-0">
                  <thead>
                    <tr>
                      <th>Seria</th>
                      <th>Număr Început</th>
                      <th>Număr Sfârșit</th>
                      <th>Facturi Emise</th>
                      <th>Facturi Anulate / Altele</th>
                      <th className="text-end" style={{ width: "100px" }}>Acțiuni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {plaje.length === 0 ? (
                      <tr>
                        <td colSpan={6} className="text-center py-3 text-muted">
                          Nu s-au definit plaje de facturi.
                        </td>
                      </tr>
                    ) : (
                      plaje.map((p, idx) => (
                        <tr key={p.bxid || idx}>
                          <td className="align-middle">
                            <Form.Control
                              size="sm"
                              value={p.seria || ""}
                              onChange={(e) => handlePlajaChange(idx, "seria", e.target.value)}
                            />
                          </td>
                          <td className="align-middle">
                            <Form.Control
                              size="sm"
                              value={p.p1 || ""}
                              onChange={(e) => handlePlajaChange(idx, "p1", e.target.value)}
                            />
                          </td>
                          <td className="align-middle">
                            <Form.Control
                              size="sm"
                              value={p.p2 || ""}
                              onChange={(e) => handlePlajaChange(idx, "p2", e.target.value)}
                            />
                          </td>
                          <td className="align-middle">
                            <Form.Control
                              size="sm"
                              value={p.p3 || ""}
                              onChange={(e) => handlePlajaChange(idx, "p3", e.target.value)}
                            />
                          </td>
                          <td className="align-middle">
                            <Form.Control
                              size="sm"
                              value={p.p4 || ""}
                              onChange={(e) => handlePlajaChange(idx, "p4", e.target.value)}
                            />
                          </td>
                          <td className="align-middle text-end">
                            <Button variant="outline-danger" size="sm" onClick={() => handleRemovePlaja(idx)}>
                              Șterge
                            </Button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Tab>
        </Tabs>
      </Form>
    </Container>
  );
}
